export const BADGE_COLORS: Record<string, { bg: string; text: string }> = {
  CONVENCIONAL: { bg: '#0f5286', text: '#fff' },
  POSTERGADO: { bg: '#1B5E20', text: '#fff' },
  URGENTE: { bg: '#B71C1C', text: '#fff' },
  ISENTO: { bg: '#E8F5E9', text: '#1B5E20' },
}
